import { t } from "@/i18n-js/instance";

export const BUTTON_TYPES = [
  {
    label: t("builder_ui.block_type.primary_button"),
    value: "primary",
    actionView: "primaryButton",
  },
  {
    label: t("builder_ui.block_type.secondary_button"),
    value: "secondary",
    actionView: "secondaryButton",
  },
];
